import React, { useEffect } from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import { useFormikContext } from 'formik';

import ChipGroupField from 'features/team/components/ChipGroup/ChipGroupField';
import { PAYMENT_METHOD_OPTIONS } from 'features/team/components/TaxEntryForm/constants';
import {
  TAX_ENTRY_I18N_PATH,
  TAX_ENTRY_PAYMENT_METHOD_PATH,
} from 'features/team/constants';
import { ADD_TEAM_PAYROLL_FLOW_STEP } from 'features/teamView/tracking';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';
import { EVENT_ACTIONS, TRACK_ACTION_TYPES } from 'util/tracking_constants';
import { useTrackUx } from 'util/uxEvents';

import BankingInformationForm from './BankingInformationForm';
const { cx } = cxHelpers('PaymentMethod');

const PaymentMethod = () => {
  const { values } = useFormikContext();

  const trackUx = useTrackUx();

  useEffect(() => {
    trackUx(EVENT_ACTIONS.PAGE_VIEWED, TRACK_ACTION_TYPES.VIEW, {
      add_team_payroll_flow_step: ADD_TEAM_PAYROLL_FLOW_STEP.PAYMENTS,
    });
  }, [trackUx]);

  const isDirectDeposit =
    values.payment_method ===
    toI18n(`${TAX_ENTRY_PAYMENT_METHOD_PATH}.direct_deposit`);

  return (
    <Box className={cx()} mt={20}>
      <Text color="mono900" variant="heading4" className="required">
        {toI18n(`${TAX_ENTRY_I18N_PATH}.payment_method`)}
      </Text>

      <Box mt={20}>
        <ChipGroupField
          name="payment_method"
          options={PAYMENT_METHOD_OPTIONS}
        />
      </Box>
      {isDirectDeposit && <BankingInformationForm />}
    </Box>
  );
};

export default PaymentMethod;
